// @ts-nocheck
goog.declareModuleId('yext.ui.components.entitypicker.container.singleselectcontainer');

import {CartModel} from '/ui/components/entitypicker/cart/cartmodel';
import {DataModel, entityTypeMatchesText} from '/ui/components/entitypicker/datasource/datamodel';
import {EntityList} from '/ui/components/entitypicker/entitylist/entitylist';
import {EntityTree} from '/ui/components/entitypicker/entitylist/entitytree';
import {LabelList} from '/ui/components/entitypicker/entitylist/labellist';
import {GroupByType, Header} from '/ui/components/entitypicker/header/header';
import {Search} from '/ui/components/entitypicker/search/singleselectsearch';
import {classNames} from '/ui/lib/classnames';

import * as styles from '/ui/components/entitypicker/container/singleselectcontainer.module.scss';

/**
 * @param {{
 *   data: !DataModel,
 *   isLoading: boolean,
 *   onShowMore: function(string): void,
 *   onSearch: function(string): void,
 *   onSelect: function(!CartModel): void,
 * }} props
 * @returns {React.ReactElement}
 */
export const SingleSelectContainer = ({
  data,
  isLoading,
  onShowMore,
  onSearch,
  onSelect,
}) => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [groupByType, setGroupByType] = React.useState(GroupByType.TYPE);
  const onSelectEntity = React.useCallback(entity => {
    onSelect(new CartModel(true).withEntity(entity));
  }, [onSelect]);

  const searchActive = searchTerm !== '';
  let listContents;
  if (searchActive || groupByType === GroupByType.TYPE) {
    listContents = (
      <EntityList
        types={data.entities.types.filter(
          type => type.entities.length > 0 || entityTypeMatchesText(type, searchTerm),
        )}
        onSelect={onSelectEntity}
        onShowMore={onShowMore}
        collapsed={searchTerm === ''} />
    );
  } else if (groupByType === GroupByType.FOLDER) {
    listContents = (
      <EntityTree
        data={data}
        onSelect={onSelectEntity}
        onShowMore={onShowMore} />
    );
  } else if (groupByType === GroupByType.LABEL) {
    listContents = (
      <LabelList
        data={data}
        onSelect={onSelectEntity}
        onShowMore={onShowMore} />
    );
  }

  return <div className={styles.container}>
    <Header setGroupByType={setGroupByType} />
    <Search searchTerm={searchTerm} onSearch={term => {
      setSearchTerm(term);
      onSearch(term);
    }} />
    <div className={classNames(styles.list, {[styles.loading]: isLoading})}>
      {listContents}
    </div>
  </div>;
};
